<template>
  <div class="menu-left" :class="{ menuIsOpen: menuIsOpen }">
    <v-navigation-drawer
      height="100%"
      width="200px"
      permanent
      :dark="darkEnabled"
    >
      <v-list dense style="text-align: left">
        <div
          v-for="(item, index) in arrayMenu"
          :key="'item-menu-' + index + '-' + item.grupo"
        >
          <v-list-item
            class="list-item"
            v-if="!item.subitens || item.subitens.length <= 1"
            link
            :href="item.link.substring(item.link.indexOf('https'))"
          >
            <v-list-item-title class="btn-font-size">
              <b>{{ item.nome }}</b>
            </v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavBarLeft",
  data: () => ({
    arrayMenu: [
      { nome: "Empresas", link: "/admin/empresa" },
      { nome: "Avaliações", link: "/admin/fornecedor/avaliacoes" },
      { nome: "Usuários", link: "/admin/usuarios" },
      { nome: "Novidades", link: "/admin/novidades" }
    ]
  }),
  computed: {
    ...mapGetters(["menuIsOpen", "darkEnabled"])
  },
  methods: {
    isGroupActive(item) {
      let filter = (item.subitens || []).filter(
        subitem => location.pathname == subitem.link
      );
      return filter.length > 0;
    },
    isMenuActive(subitem) {
      return location.pathname.endsWith(subitem.link);
    }
  }
};
</script>

<style lang="scss">
.menu-left {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 65px;
  transform: translate3d(0px, 0px, 0px);
  transition: all 0.3s ease-in-out;
  background-color: #f7f9fa;
  .list-subitem {
    padding-left: 25px;
  }
  .v-list-item--link {
    border-bottom: 1px solid #e4e5e7;
  }
}
@media (max-width: 768px) {
  .menu-left {
    transform: translate3d(0px, 0px, 0px);
    &.menuIsOpen {
      transform: translate3d(-201px, 0px, 0px);
    }
  }
}
.chat-budge-menu {
  background-color: #ff1e19;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: flex;
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  font-size: 12px;
  color: #ffff;
}
</style>
